import React, { Suspense } from "react";
import "./header.scss";
import { LeftArrowIcon, InfoIcon } from "../../../assets/Icons";
import { getNonProdEnvName } from "../../../utilities/utils";

type HeaderProps = {
  currentStep: number;
  totalSteps: number;
  showBackButton: boolean;
  customBackAction?: () => void;
  onInfoClick?: () => void;
  brand?: string | null;
};

const Header: React.FC<HeaderProps> = ({
  currentStep,
  totalSteps,
  showBackButton,
  customBackAction,
  onInfoClick,
  brand,
}) => {
  const envName = getNonProdEnvName();

  const handleBackPress = () => {
    if (customBackAction) customBackAction();
  };

  return (
    <div className="header">
       <div className="left-view">
        {showBackButton && (
        <div className="back-button" onClick={handleBackPress}>
          <Suspense fallback={null}>
            <LeftArrowIcon key={brand || 'default'} />
          </Suspense>
        </div>
        )}
     
       <div className="progress-indicator">
        {Array.from({ length: totalSteps }, (_, index) => {
          const isActiveStep = index === currentStep - 1;

          return (
            <div key={index} className="progress-item">
              {isActiveStep ? (
                <div className="line active"></div>
              ) : (
                <div className={`dot ${index < currentStep - 1 ? "completed" : ""}`}></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
    <div className="header-title">
      <span>Instant </span>
      <span className="quote-text">
        quote
      </span>
      {envName && <span className="env-badge">{envName.toUpperCase()}</span>}
    </div>
      <div className="info-button" onClick={onInfoClick}>
        <Suspense fallback={null}>
          <InfoIcon key={brand || 'default'} />
        </Suspense>
      </div>
    </div>
  );
};

export default Header;
